import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable()
export class TimesheetLocalizationService {
	constructor(
		private configService: ConfigService
	) {}

	// hour rules for OT/SD/CO
	getHourRules(countryCode: string): Array<(props: any, responseReturnObject: Array<string>) => boolean> {
		const rulesToApply: Array<(props: any, responseReturnObject: Array<string>) => boolean> = [];

		// add rules to the list that are required
		if ( this.configService.countryCodes.UK.indexOf(countryCode) >= 0) {
			rulesToApply.push(this.mustFulfillDailySTBeforeOTWeekdaysNonHolidays);
			rulesToApply.push(this.mustApplyUKPwdOTRules);
		}

		if ( this.configService.countryCodes.IE.indexOf(countryCode) >= 0 ) {
			rulesToApply.push(this.mustHaveSDCOHoursDivisibleByEight);
		}

		// return the rules that apply
		return rulesToApply;
	}


	// note: the following rules will be run outside this service, so the 'this' keyword will not work. pass in values as props
	// OT rule - must fulfill daily ST before OT on weekdays (not holidays)
	mustFulfillDailySTBeforeOTWeekdaysNonHolidays(props: any, responseReturnObject: Array<string>): boolean {
		if (props.laborType?.includes('Professional')
			&& props.totalsByType['overtime'] > 0
			&& props.weekDay !== 'Sun'
			&& props.weekDay !== 'Sat'
			&& props.bankHolidays?.indexOf(props.totalsByType.date) < 0
			&& props.totalsByType['totalST'] < props.dailyStandardHourLimit
		) {
			responseReturnObject.push(`To claim overtime, ${props.dailyStandardHourLimit} standard or straight time hours are needed.`);
			return false;
		}
		return true;
	};

	// OT rule:
	// for non-PWD, OT hours needs be divisible by 4 (applicable to Mon-Sat and not holidays)
	// for PWD, OT hours must be less than 19 hours (applicable to Mon-Sat and not holidays) 
	mustApplyUKPwdOTRules(props: any, responseReturnObject: Array<string>): boolean {
		const isPWD = props.laborType?.startsWith('Professional');
		if (props.laborType?.includes('Professional')
			&& props.totalsByType['overtime'] > 0
			&& props.weekDay !== 'Sun'
			&& props.bankHolidays?.indexOf(props.totalsByType.date) < 0
		) {
			let blockSubmit = false;
			let response = '';
			if (isPWD) {
				// check overtime limits for certain days of week
				if (props.totalsByType['overtime'] > 19) {
					response = 'For Monday - Saturday, overtime can not exceed 19 hours';
					blockSubmit = true;
				}
			}
			if (response.length > 0) {
				responseReturnObject.push(response);
			}
			if (blockSubmit) {
				return false;
			}
		}
		return true;
	};

	// SD/CO rule - hours must be divisible by 8 (applicable to Mon-Sat and not holidays)
	mustHaveSDCOHoursDivisibleByEight(props: any, responseReturnObject: Array<string>): boolean {
		let isValid = true;
		// For IE, there are two types contractor: Technical Service and Complementary Workforce
		// For TSC	
		const isTSC = props.laborType?.toLowerCase().startsWith('technical');

		// for Standby and Remote Callout
		if (props.totalsByType['standby'] > 0 || props.totalsByType['remotecallout'] > 0) {
			let response = '';
			let divByEightMessage = 'Standby or Remote Callout needs to be claimed for every 8 working hours (0,8,16 or 24) at a time.';
			let isWeekday = false;
			// check for Mon-Fri ( non bank holiday )
			if (props.weekDay !== 'Sat'
				&& props.weekDay !== 'Sun'
				&& props.bankHolidays?.indexOf(props.totalsByType.date) < 0) {
				divByEightMessage = 'Standby or Remote Callout needs to be claimed for every 8 working hours at a time (0,8,16).';
				isWeekday = true;
			}
			// if overtime is not divisible by 8, warn for everyone, and block submit
			if (props.totalsByType['standby'] && props.totalsByType['standby'] % 8 !== 0
				|| props.totalsByType['remotecallout'] && props.totalsByType['remotecallout'] % 8 !== 0) {
				response = divByEightMessage;
				isValid = false;
			}

			// check TSC SD/CO limits for weekday ( non bank holiday )
			if (isTSC && isWeekday && (props.totalsByType['standby'] > 16 || props.totalsByType['remotecallout'] > 16)) {
				response = response + ' For Monday - Friday (non bank holiday), Standby or Remote Callout cannot be more than 16 hours.';
				isValid = false;
			}

			if (response.length > 0) {
				responseReturnObject.push(response);
			}
		}

		//for TSC onsite callout
		if (isTSC) {
			if (props.totalsByType['onsitecallout'] > 4) {
				responseReturnObject.push('Onsite callout cannot be more than 4 hours, additional hours need go to the overtime type.');
				isValid = false;
			} else if (props.totalsByType['onsitecallout'] && props.totalsByType['onsitecallout'] % 4 !== 0) {
				responseReturnObject.push('Onsite callout needs to be claimed either 0 or 4 hours');
				isValid = false;
			}
		}
			
		return isValid;
	};
}
